export default "__VITE_ASSET__db6310ed__"